/* eslint-disable no-global-assign */
/* global globalThis */
var processBrowser = require('process/browser')
if (typeof window !== 'undefined') window.process = processBrowser
if (typeof global !== 'undefined') global.process = processBrowser
if (typeof globalThis !== 'undefined') globalThis.process = processBrowser
